import { AfterViewInit, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { BasePage } from '../../base.page';
import { Client } from '../../../domain/data';
import { ClientType, GetFirstHolderUseCase, UpdateFirstHolderUseCase } from '../../../../core';
import { ContractPage } from '../contract.page';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';

@Component({
    templateUrl: './contract-natural.page.html',
    styleUrls: ['./contract-natural.page.scss'],
})
export class ContractNaturalPage extends BasePage implements AfterViewInit, OnInit, OnDestroy {
    private client: Client;
    private backSubscription: Subscription;

    constructor(
        contractPage: ContractPage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getFirstHolderUseCase: GetFirstHolderUseCase,
        private renderer: Renderer2,
        private router: Router,
        private updateFirstHolderUseCase: UpdateFirstHolderUseCase
    ) {
        super(parentEvents);
        contractPage.showBackButton();
        this.backSubscription = contractPage.back.subscribe(() => {
            window.history.back();
        });
    }

    ngOnInit() {
        this.getFirstHolder();
        this.renderer.addClass(document.body, 'bg-blue-gradient');
    }

    private getFirstHolder() {
        this.getFirstHolderUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.client = transaction.data as Client;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    ngOnDestroy() {
        this.backSubscription.unsubscribe();
        this.renderer.removeClass(document.body, 'bg-blue-gradient');
    }

    onClick(isMinorOrDisabled) {
        if (isMinorOrDisabled) {
            this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_MINOR_DISABLED);
        } else {
            this.client.type = ClientType.NATURAL_PERSON;

            this.updateFirstHolderUseCase.bind({ client: this.client }).subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.router.navigateByUrl(MainRoutes.NEW_CONTRACT_FORM);
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
        }
    }
}
